import { useEffect, useRef, useState } from "react";
import { useGetFAQQuery } from "../../redux/Apis/FAQ";
import Loader from "../loader";
import { useTranslate } from "../../context/TranslationContext";
import { useSelector } from "react-redux";

const FaqSection = () => {
  const { t } = useTranslate();
  const lang = useSelector((state) => state.language.lang);
  const { data, isLoading, refetch } = useGetFAQQuery({
    params: { lang },
  });
  const [isMainOpen, setIsMainOpen] = useState(true);
  const [openCategory, setOpenCategory] = useState(null);
  const [openQuestion, setOpenQuestion] = useState({});

  const mainFaqRef = useRef(null);
  const categoryRefs = useRef({});
  const questionRefs = useRef({});

  useEffect(() => {
    if (mainFaqRef.current) {
      const el = mainFaqRef.current;
      if (isMainOpen) {
        el.style.maxHeight = el.scrollHeight + "px";
        const timeout = setTimeout(() => {
          el.style.maxHeight = "none";
        }, 600);
        return () => clearTimeout(timeout);
      } else {
        el.style.maxHeight = el.scrollHeight + "px";
        requestAnimationFrame(() => {
          el.style.transition = "max-height 0.6s ease-in-out";
          el.style.maxHeight = "0px";
        });
      }
    }
  }, [isMainOpen]);

  useEffect(() => {
    Object.entries(categoryRefs.current).forEach(([key, ref]) => {
      if (ref) {
        const isOpen = parseInt(key) === openCategory;
        ref.style.maxHeight = isOpen ? ref.scrollHeight + "px" : "0px";
        if (isOpen) {
          const timeout = setTimeout(() => {
            ref.style.maxHeight = "none";
          }, 500);
          return () => clearTimeout(timeout);
        }
      }
    });
  }, [openCategory]);

  useEffect(() => {
    Object.entries(questionRefs.current).forEach(([key, ref]) => {
      if (ref) {
        const isOpen = openQuestion[key];
        ref.style.maxHeight = isOpen ? ref.scrollHeight + "px" : "0px";
        if (isOpen) {
          const timeout = setTimeout(() => {
            ref.style.maxHeight = "none";
          }, 400);
          return () => clearTimeout(timeout);
        }
      }
    });
  }, [openQuestion]);

  useEffect(() => {
    refetch({ params: { lang } });
  }, [lang, refetch]);

  if (isLoading)
    return (
      <p className="text-center">
        <Loader loading={true} />
      </p>
    );

  return (
    <section className="faq py-sm-5 py-4">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <h2
              className="gallery-title text-uppercase text-white mb-3"
              style={{ cursor: "pointer" }}
              onClick={() => setIsMainOpen(!isMainOpen)}
            >
              {t("faq.question")}
            </h2>
            <p className="mb-4 p-lg l-grey-text">{t("faq.answer")}</p>
          </div>

          <div
            ref={mainFaqRef}
            style={{
              overflow: "hidden",
            }}
          >
            <div className="col-xxl-7 mx-auto mt-4 col-xl-8 col-lg-9 col-md-10 col-12">
              <div className="accordion faq-accordion" id="mainFaqAccordion">
                {data?.data?.map((category, catIdx) => (
                  <div key={category._id} className="mb-3">
                    <div
                      className="accordion-item"
                      style={{
                        boxShadow: "none",
                        backgroundColor: "transparent",
                      }}
                      onClick={() =>
                        setOpenCategory((prev) =>
                          prev === catIdx ? null : catIdx
                        )
                      }
                    >
                      <h2 className="accordion-header">
                        <button
                          className={`accordion-button text-capitalize ${
                            openCategory === catIdx ? "" : "collapsed"
                          }`}
                          type="button"
                          style={{ fontSize: "30px", fontWeight: 500 }}
                        >
                          {category.name}
                        </button>
                      </h2>
                    </div>

                    <div
                      ref={(el) => (categoryRefs.current[catIdx] = el)}
                      className="accordion-collapse"
                      style={{
                        maxHeight: "0px",
                        overflow: "hidden",
                        transition: "max-height 0.5s ease-in-out",
                      }}
                    >
                      <div className="accordion-body">
                        {category.questions.map((q, qIdx) => {
                          const key = `${catIdx}-${qIdx}`;
                          return (
                            <div
                              className="accordion-item mb-2"
                              key={q._id}
                              onClick={() =>
                                setOpenQuestion((prev) => ({
                                  ...prev,
                                  [key]: !prev[key],
                                }))
                              }
                            >
                              <h2 className="accordion-header">
                                <button
                                  className={`accordion-button ${
                                    openQuestion[key] ? "" : "collapsed"
                                  }`}
                                  type="button"
                                >
                                  {q.que}
                                </button>
                              </h2>
                              <div
                                ref={(el) => (questionRefs.current[key] = el)}
                                className="accordion-collapse"
                                style={{
                                  maxHeight: "0px",
                                  overflow: "hidden",
                                  transition: "max-height 0.4s ease-in-out",
                                }}
                              >
                                <div className="accordion-body">
                                  <p className="mb-0">{q.ans}</p>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
